export const validatePhoneNumber = (phone: string): string | null => {
  const cleanedPhone = phone.replace(/\D/g, '');
  const phoneRegex = /^\d{11}$/;

  if (!phoneRegex.test(cleanedPhone)) {
    return 'Número de celular inválido. Deve conter 11 dígitos.';
  }

  const ddd = cleanedPhone.substring(0, 2);
  const phoneNumber = cleanedPhone.substring(2);

  if (/^(\d)\1{8}$/.test(phoneNumber)) {
    return 'Não pode conter todos os dígitos iguais nos 9 dígitos do telefone.';
  }

  if (isSequential(phoneNumber)) {
    return 'Não pode conter sequência numérica nos 9 dígitos do telefone.';
  }

  return null;
};

/**
 * Verifica se o número contém uma sequência numérica ascendente ou descendente de 5 ou mais dígitos.
 * @param {string} number - Número a ser verificado (9 dígitos do telefone, sem o DDD).
 * @returns {boolean} - True se contiver sequência, false caso contrário.
 */

const isSequential = (number: string): boolean => {
  const digits = number.split('').map((d) => parseInt(d));

  const sequenceLength = 5;

  for (let i = 0; i <= digits.length - sequenceLength; i++) {
    let isAscending = true;
    for (let j = i; j < i + sequenceLength - 1; j++) {
      if (digits[j] + 1 !== digits[j + 1]) {
        isAscending = false;
        break;
      }
    }
    if (isAscending) {
      return true;
    }
  }

  for (let i = 0; i <= digits.length - sequenceLength; i++) {
    let isDescending = true;
    for (let j = i; j < i + sequenceLength - 1; j++) {
      if (digits[j] - 1 !== digits[j + 1]) {
        isDescending = false;
        break;
      }
    }
    if (isDescending) {
      return true;
    }
  }

  return false;
};
